import { useEffect } from "react";
import {useEditorStore} from "../../../stores";
import { useAxesAlignmentStore } from "../../../stores";
import { useShallow } from "zustand/shallow";
import AxesHandler from "./AxesHandler";
import AlignmentHandler from "./AlignmentHandler";
import { TOOLS_CONFIG } from "../../../constants/tools";


const AxesAlignmentHandler = () => {

    const activeTool = useEditorStore(s => s.activeTool);

    return (
        <div className='w-full h-full'>
            {activeTool === TOOLS_CONFIG.SCAN_PROCESS.AXES_ALIGNMENT.AXES.id && <AxesHandler/>}
            {activeTool === TOOLS_CONFIG.SCAN_PROCESS.AXES_ALIGNMENT.ALINGMENT.id && <AlignmentHandler/>}
        </div>
    );
};
export default AxesAlignmentHandler;